import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleText, SingleSelect, SingleInput, SingleDatePickerInput } from '../../Res/BaseInput';
import { Space, CancelSubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { getval2Token } from '../../../Login/Auth';
import { getCaseStatus } from '../../../../item/ItemRecruitmentContractorStatus';
import { RespRecruitmentContractorDetail } from '../../../../item/ItemRecruitmentContractor';
import moment from 'moment';
import { ReqInsurance, InsuranceStatus_Arr, HealthInsuranceStatus_Arr, ReqLaborInsurance, ReqHealthInsurance, ReqGroupInsurance, RespInsurance } from '../../../../item/ItemInsurance';
import { api_getCustomerPositionDetail } from '../../../../api/apiCustomerPosition';
import { api_getLaborInsuranceLevel_Arr, api_getHealthInsuranceLevel_Arr } from '../../../../api/apiOpenData';
import { ReqCustomerPositionDetail, RespCustomerPosition } from '../../../../item/ItemCustomerPosition';
import { api_setRecruitmentContractorInsurance, api_getRecruitmentContractorInsurance } from '../../../../api/apiRecruitmentContractorInsurance';


export function InsuranceReviseSOP({ id, setIsLoading, isEdit = false, isML = false, isAll = false }) {
  const [tokenId, setTokenId] = useState("")
  const [respRecruitmentContractorDetail, setRespRecruitmentContractorDetail] = useState(new RespRecruitmentContractorDetail({}))
  const [item, setItem] = useState(null)
  const [isBlacklist, setIsBlacklist] = useState(false)
  const [isBlacklistStr, setIsBlacklistStr] = useState("")

  const [name, setName] = useState("")
  const [contractorJobStatusDescription, setContractorJobStatusDescription] = useState("")
  const [sex, setSex] = useState("")
  const [age, setAge] = useState("")
  const [mobile, setMobile] = useState("")
  const [contractorSupervisor, setContractorSupervisor] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [job, setJob] = useState("")
  const [workPlace, setWorkPlace] = useState("")
  const [workAddress, setWorkAddress] = useState("")

  const [insurance, setInsurance] = useState(new RespInsurance({}))
  const [insuredUnitGUI, setInsuranceUnitGUI] = useState("")

  const [laborInsuranceStatusDescription, setLaborInsuranceStatusDescription] = useState("")
  const [laborInsuranceStatus, setLaborInsuranceStatus] = useState("")
  const [laborInsuranceDate, setLaborInsuranceDate] = useState("")
  const [laborInsuranceAmount, setLaborInsuranceAmount] = useState("")
  const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("")

  // const [laborPensionStatusDescription, setLaborPensionStatusDescription] = useState("")
  // const [laborPensionStatus, setLaborPensionStatus] = useState("")
  // const [laborPensionDate, setLaborPensionDate] = useState("")
  // const [laborPensionAmount, setLaborPensionAmount] = useState("")
  // const [laborPensionLevel, setLaborPensionLevel] = useState("")

  const [healthInsuranceStatusDescription, setHealthInsuranceStatusDescription] = useState("")
  const [healthInsuranceStatus, setHealthInsuranceStatus] = useState("")
  const [healthInsuranceDate, setHealthInsuranceDate] = useState("")
  const [healthInsuranceAmount, setHealthInsuranceAmount] = useState("")
  const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("")

  const [groupInsuranceGUI, setGroupInsuranceGUI] = useState("")
  const [groupInsuranceStatusDescription, setGroupInsuranceStatusDescription] = useState("N/A")
  const [groupInsuranceStatus, setGroupInsuranceStatus] = useState("")
  const [groupInsuranceDate, setGroupInsuranceDate] = useState("")

  const [laborInsuranceType, setLaborInsuranceType] = useState("")
  const [laborInsuranceLevel_Arr, setLaborInsuranceLevel_arr] = useState([])
  const [healthInsuranceLevel_Arr, setHealthInsuranceLevel_Arr] = useState([])
  const [dateError, setDateError] = useState(false)
  const [dateErrorArr, setDateErrorArr] = useState([])
  const [customerPosition, setCustomerPosition] = useState({})

  const Tilel_LaborInsuranceLevel = "投保級距-改變後的"
  const Tilel_HealthInsuranceLevel = "健保級距-改變後的"

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var detail = getval2Token("recruitmentContractorStatusDetail", id)
      var insurance = getval2Token("recruitmentContractorStatusDetailInsurance", id)
      console.log(detail)
      // var rId = getval2Token("resumeId", id)
      if (detail.isBlack) {
        setIsBlacklist(true)
        setIsBlacklistStr("--黑名單")
      }
      setName(detail.name)

      var mRespRecruitmentContractorDetail = new RespRecruitmentContractorDetail({})
      mRespRecruitmentContractorDetail.fromJson(detail)
      var cs = getCaseStatus(mRespRecruitmentContractorDetail, mRespRecruitmentContractorDetail.caseInfo)
      console.log(mRespRecruitmentContractorDetail)
      setRespRecruitmentContractorDetail(mRespRecruitmentContractorDetail)
      

      var mReqCustomerPositionDetail = new ReqCustomerPositionDetail({
        customerPositionId: mRespRecruitmentContractorDetail.caseInfo.customerPositionId,
      })
      getCustomerPositionDetail(mReqCustomerPositionDetail)

      // console.log(cs)
      setContractorJobStatusDescription(detail.contractorJobStatusDescription + " " + moment(cs.statusDeta).format('YYYY/MM/DD'))
      const startDate = moment(detail.birthday);
      const endDate = moment(new Date());
      const age = endDate.diff(startDate, 'years');
      setAge(age)
      setSex(detail.sex === "1" ? "男" : detail.sex === "1" ? "女" : "")
      setMobile(detail.mobile)
      setContractorSupervisor(detail.caseOwnerName)
      if (detail.contractorJobStatus === 0) {
        setCompanyName("N/A")
        setJob("N/A")
        setWorkPlace("N/A")
        setWorkAddress("N/A")
      } else {
        setCompanyName(mRespRecruitmentContractorDetail.caseInfo.caseCompanyName)
        setJob(mRespRecruitmentContractorDetail.caseInfo.caseCustomerPosition)
        setWorkPlace(mRespRecruitmentContractorDetail.caseInfo.caseWorkPlace)
        setWorkAddress(mRespRecruitmentContractorDetail.caseInfo.caseWorkAddress)
      }

      var mRespInsurance = new RespInsurance({})
      mRespInsurance.fromJson(insurance)
      console.log(mRespInsurance)
      setInsurance(mRespInsurance)

      setInsuranceUnitGUI(mRespInsurance.insuredUnitGUI)

      setLaborInsuranceStatusDescription(mRespInsurance.laborInsurance.description)
      // setLaborInsuranceStatus(mReqInsurance.laborInsurance.status)
      // setLaborInsuranceDate(mReqInsurance.laborInsurance.date)
      // setLaborInsuranceAmount(mReqInsurance.laborInsurance.amount)
      // setLaborInsuranceAmount(mReqInsurance.laborInsurance.amount)

      // setLaborPensionStatusDescription(mReqInsurance.laborPension.description)
      // setLaborPensionStatus(mReqInsurance.laborPension.status)
      // setLaborPensionDate(mReqInsurance.laborPension.date)
      // setLaborPensionAmount(mReqInsurance.laborPension.amount)

      setHealthInsuranceStatusDescription(mRespInsurance.healthInsurance.description)
      // setHealthInsuranceStatus(mReqInsurance.healthInsurance.status)
      // setHealthInsuranceDate(mReqInsurance.healthInsurance.date)
      // setHealthInsuranceAmount(mReqInsurance.healthInsurance.amount)

      setGroupInsuranceGUI(mRespInsurance.groupInsurance.groupInsuranceGUI)
      setGroupInsuranceStatusDescription(mRespInsurance.groupInsurance.description)
      // setGroupInsuranceStatus(mReqInsurance.groupInsurance.status)
      // setGroupInsuranceDate(mReqInsurance.groupInsurance.date)
      getLaborInsuranceLevel_Arr()
      getHealthInsuranceLevel_Arr()
      setIsLoading(false)
      setTokenId(id)
    }
  }, [id])

  useEffect(()=>{
    if(respRecruitmentContractorDetail.caseContractor !== undefined)
    getInsurance()
  },[respRecruitmentContractorDetail])

  function getInsurance(){
    setIsLoading(true)
    var mReqInsurance = new ReqInsurance({
      caseContractor: respRecruitmentContractorDetail.caseContractor,
      recruitmentContractorId: respRecruitmentContractorDetail.recruitmentContractorId
    })
    api_getRecruitmentContractorInsurance({
      mReqInsurance,
      success:(jsonData)=>{
        // console.log(jsonData.insurance)
        var mReqInsurance = new ReqInsurance({})
        mReqInsurance.fromJson(jsonData.insurance)
        // console.log(mReqInsurance.insuranceInfo)

        var mRespInsurance = new RespInsurance({})
        mRespInsurance.fromJson(mReqInsurance.insuranceInfo)
        // console.log(mRespInsurance)
        setInsurance(mRespInsurance)
  
        // setInsuranceUnitGUI(mRespInsurance.insuredUnitGUI)
        setLaborInsuranceStatusDescription(mRespInsurance.laborInsurance.description)
        setHealthInsuranceStatusDescription(mRespInsurance.healthInsurance.description)
        // setGroupInsuranceGUI(mRespInsurance.groupInsurance.groupInsuranceGUI)
        setGroupInsuranceStatusDescription(mRespInsurance.groupInsurance.description)
        setIsLoading(false)
      },
      failure:(err)=>{
        setIsLoading(false)
      }
    })
  }

  function toCancel() {
    window.history.back();
  }
  useEffect(()=>{
    // console.log(insurance)
  },[insurance])

  function toAction() {
    if(dateError){
      
      Swal.fire({
          type: 'error',
          title: '提醒',
          text: dateErrorArr.join(',')+' 日期格式有誤, 請確認月日為2位數',
      })
      return
    }
    setIsLoading(true)
    var laborInsuranceAmount = laborInsuranceLevel_Arr[laborInsuranceType + ""][laborInsuranceLevel-1]
    var laborInsurance = new ReqLaborInsurance({
      status: laborInsuranceStatus === "" ? insurance.laborInsurance.status : laborInsuranceStatus,
      date: laborInsuranceDate === "" ? insurance.laborInsurance.date : laborInsuranceDate,
      amount: laborInsuranceLevel === "" ? insurance.laborInsurance.amount : laborInsuranceAmount.amount,
      level: laborInsuranceLevel === "" ? insurance.laborInsurance.level : laborInsuranceLevel,
    })

    var healthInsuranceAmount = healthInsuranceLevel_Arr[healthInsuranceLevel-1]
    var healthInsurance = new ReqHealthInsurance({
      status: healthInsuranceStatus === "" ? insurance.healthInsurance.status : healthInsuranceStatus,
      date: healthInsuranceDate === "" ? insurance.healthInsurance.date : healthInsuranceDate,
      amount: healthInsuranceLevel === "" ? insurance.healthInsurance.amount : healthInsuranceAmount.amount,
      level: healthInsuranceLevel === "" ? insurance.laborInsurance.level : healthInsuranceLevel,
    })
    var groupInsurance = new ReqGroupInsurance({
      status: groupInsuranceStatus === "" ? insurance.groupInsurance.status : groupInsuranceStatus,
      date: groupInsuranceDate === "" ? insurance.groupInsurance.date : groupInsuranceDate,
      groupInsuranceGUI: groupInsuranceGUI === "" ? insurance.groupInsurance.groupInsuranceGUI : groupInsuranceGUI,
    })

    var mRespInsurance = new RespInsurance({
      insuredUnitGUI: insuredUnitGUI === "" ? insurance.insuredUnitGUI : insuredUnitGUI,
      laborInsurance,
      healthInsurance,
      groupInsurance
    })
    var mReqInsurance = new ReqInsurance({
      caseContractor: respRecruitmentContractorDetail.caseContractor,
      recruitmentContractorId: respRecruitmentContractorDetail.recruitmentContractorId,
      insuranceInfo: JSON.stringify(mRespInsurance) 
    })
    console.log(mRespInsurance)
    console.log(mReqInsurance)
    api_setRecruitmentContractorInsurance({
      mReqInsurance,
      success:(jsonData)=>{
        setInsurance(mRespInsurance)
        // setInsuranceUnitGUI(mRespInsurance.insuredUnitGUI)
        setLaborInsuranceStatusDescription(mRespInsurance.laborInsurance.description)
        setHealthInsuranceStatusDescription(mRespInsurance.healthInsurance.description)
        // setGroupInsuranceGUI(mRespInsurance.groupInsurance.groupInsuranceGUI)
        setGroupInsuranceStatusDescription(mRespInsurance.groupInsurance.description)
        setIsLoading(false)
        Swal.fire({
            type: 'success',
            title: '提醒',
            text: '保險資訊修正完成',
        })
      },
      failure:(err)=>{
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function getCustomerPositionDetail(mReqCustomerPositionDetail) {
    // console.log(mReqCustomerPositionDetail)
    api_getCustomerPositionDetail({
      mReqCustomerPositionDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespCustomerPosition = new RespCustomerPosition({})
        try {
          mRespCustomerPosition.fromJson(jsonData.detail)
          console.log(mRespCustomerPosition)
          setCustomerPosition(mRespCustomerPosition)
          setLaborInsuranceType(mRespCustomerPosition.info.insuranceInfo.laborInsuranceType)
          setIsLoading(false)
        } catch (error) {
          setIsLoading(false)
          Swal.fire({
              type: 'success',
              title: '提醒',
              text: '保險資訊有誤',
            }).then(() => {
              window.history.go(-1)
            })
        }
        // setJob(mRespCustomerPosition.info.job)
        // setShift(mRespCustomerPosition.info.shift)
        // setWorkPlace(mRespCustomerPosition.info.workPlace)
        // setWorkAddress(mRespCustomerPosition.info.workAddress)
        // setJobRequirement(mRespCustomerPosition.info.jobRequirement)
        // setJobDemand(mRespCustomerPosition.info.jobDemand)
        // setWageType(mRespCustomerPosition.info.wageType)
        // setWageInfo(mRespCustomerPosition.info.wageInfo)
        // setInsuranceInfo(mRespCustomerPosition.info.insuranceInfo)
        // setInsurance(mRespCustomerPosition.info.insuranceInfo)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        Swal.fire({
            type: 'success',
            title: '提醒',
            text: '保險資訊有誤',
          }).then(() => {
            window.history.go(-1)
          })
      }
    })
  }

  function getLaborInsuranceLevel_Arr() {
    api_getLaborInsuranceLevel_Arr({
      success: (jsonData) => {
        try {
          var detail = JSON.parse(jsonData.detail.info)
          // console.log(detail)
          setLaborInsuranceLevel_arr(detail)
          // console.log(detail)
        } catch (error) {
          console.log(error)
        }
      },
      failure: (err) => {

      }
    })
  }

  function getHealthInsuranceLevel_Arr() {
    api_getHealthInsuranceLevel_Arr({
      success: (jsonData) => {
        // console.log(jsonData)
        var detail = JSON.parse(jsonData.detail.info)
        setHealthInsuranceLevel_Arr(detail)
      },
      failure: (err) => {

      }
    })
  }

  const checkDateError = (isError, errString) => {
    if (!dateError) {
      console.log("沒有")
      console.log(isError)
      setDateError(isError)
    } else {
      console.log("已有")
      console.log(isError)
      if (dateErrorArr.length === 0)
        setDateError(isError)
    }
    var errors = dateErrorArr.filter(error => {
      return error !== errString
    })
    if (isError && errString !== "") {
      errors.push(errString)
    }
    console.log(errors)
    setDateErrorArr(errors)
  }

  var superTitle = name + isBlacklistStr
  var title = "目前的工作狀態"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"工作狀態"} val={contractorJobStatusDescription} />
          <SingleText title={"性別/年齡"} val={sex + "/" + age} />
          <SingleText title={"手機號碼"} val={mobile} />
          <SingleText title={"直屬專員"} val={contractorSupervisor} />
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"合約廠商"} val={companyName} />
          <SingleText title={"職缺"} val={job} />
          <SingleText title={"工作地點"} val={workPlace} />
          <SingleText title={"工作地址"} val={workAddress} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">

          <div className="col-md-12">
            <p className="text-success">注意：改變保險狀態(加保中、已退保)、保險日期、保險級距，”會影響保險費用計算“、”待加退保人員列表“！務必自行追蹤！</p>
          </div>
          <div className="col-md-12">
            <p className="text-success">例如：派遣工工作狀態是“已上工”，改變成“已退保”，該派遣工就會出現在“待加保人員列表”內。</p>
          </div>

        </div>
      </div>
      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleText title={"勞健保的投保單位統編-目前的"} val={insurance.insuredUnitGUI === "" ? 'N/A' : insurance.insuredUnitGUI} />
          <SingleInput title={"勞健保的投保單位統編-改變後的"} val={insuredUnitGUI} action={setInsuranceUnitGUI} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"勞保勞退狀態-目前的"} val={laborInsuranceStatusDescription} />
          <SingleSelect title={"勞保勞退狀態-改變後的"}
            val={laborInsuranceStatus}
            attr={InsuranceStatus_Arr}
            action={setLaborInsuranceStatus}
            size={3}
            hasBlank={true}
          />
          <SingleDatePickerInput
            title={"勞保勞退日期-改變後的"}
            value={laborInsuranceDate}
            action={setLaborInsuranceDate}
            feedback={checkDateError}
            errString={"勞保勞退日期"}
          />
          <SingleSelect title={Tilel_LaborInsuranceLevel}
            val={laborInsuranceLevel}
            attr={laborInsuranceLevel_Arr[laborInsuranceType + ""] === undefined ? [] : laborInsuranceLevel_Arr[laborInsuranceType + ""]}
            action={setLaborInsuranceLevel}
            v={"level"}
            n={"amount"}
            optionN={[
              { ov: "n", on: "第" },
              { ov: "k", on: "level" },
              { ov: "n", on: "級" },
              { ov: "n", on: " " },
              { ov: "k", on: "amount" },
              { ov: "n", on: "元" },
            ]}
            hasBlank={true}
            size={3}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"健保狀態-目前的"} val={healthInsuranceStatusDescription} />
          <SingleSelect title={"健保狀態-改變後的"}
            val={healthInsuranceStatus}
            attr={HealthInsuranceStatus_Arr}
            action={setHealthInsuranceStatus}
            size={3}
            hasBlank={true}
          />
          <SingleDatePickerInput
            title={"健保日期-改變後的"}
            value={healthInsuranceDate}
            action={setHealthInsuranceDate}
            feedback={checkDateError}
            errString={"健保日期"}
          />
          <SingleSelect title={Tilel_HealthInsuranceLevel}
            val={healthInsuranceLevel}
            attr={healthInsuranceLevel_Arr}
            action={setHealthInsuranceLevel}
            v={"level"}
            n={"amount"}
            optionN={[
              { ov: "n", on: "第" },
              { ov: "k", on: "level" },
              { ov: "n", on: "級" },
              { ov: "n", on: " " },
              { ov: "k", on: "amount" },
              { ov: "n", on: "元" },
            ]}
            hasBlank={true}
            blankVal={"0"}
            size={3}
          // debug={true}
          />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          {/* {console.log(insurance.groupInsurance===undefined?'N/A':insurance.groupInsurance.groupInsuranceGUI === "" ? 'N/A' : insurance.groupInsurance.groupInsuranceGUI)} */}
          <SingleText title={"團保的保險公司統編-目前的"} val={insurance.groupInsurance===undefined?'N/A':insurance.groupInsurance.groupInsuranceGUI === "" ? 'N/A' : insurance.groupInsurance.groupInsuranceGUI} />
          <SingleInput title={"團保的保險公司統編-改變後的"} val={groupInsuranceGUI} action={setGroupInsuranceGUI} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"團保狀態-目前的"} val={groupInsuranceStatusDescription} />
          <SingleSelect title={"團保狀態-改變後的"}
            val={groupInsuranceStatus}
            attr={InsuranceStatus_Arr}
            action={setGroupInsuranceStatus}
            size={3}
            hasBlank={true}
          />
          <SingleDatePickerInput
            title={"團保日期-改變後的"}
            value={groupInsuranceDate}
            action={setGroupInsuranceDate}
            feedback={checkDateError}
            errString={"團保日期"}
          />
        </div>
      </div>
    </>
  var footer =
    <div className="row text-right ">
      <div className="col-sm-12">
        <CancelSubmitButton cancelAction={toCancel} submitName={"確定"} submitAction={toAction} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} footer={footer} hasDrawer={false} />
    </>
  )
}